import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  environment: any = environment.config;

}
